export default __webpack_public_path__ + "static/blog-post-2-516dd7b62cf3f995ac42a8f18c0d5de5.png";